import { createAsyncThunk } from '@reduxjs/toolkit';

import { carAPI } from '@/modules/car/api';
import { CarFull } from '@/modules/car/model';
import { namespace } from '@/modules/car/namespace';

import { setCar } from '../actions';

const loadCarById = createAsyncThunk(
  `${namespace}/load-car-by-id`,
  async (id: string | undefined, { dispatch }): Promise<CarFull | undefined> => {
    if (!id) {
      return undefined;
    }

    const car = await carAPI.fetchCarById(id);

    dispatch(setCar(car));

    return car;
  },
);

export { loadCarById };
